import { useEffect, useState } from 'react'
import { getWipAiStaffUtilization } from '../../../entities/wipReportAi/service'

export default function useStaffUtilization({ client, projectId, month }) {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!client || !projectId || !month) {
      setRows([])
      setError(null)
      setLoading(false)
      return undefined
    }

    let cancelled = false
    setLoading(true)
    setError(null)

    getWipAiStaffUtilization(client, String(projectId), String(month))
      .then(data => {
        if (!cancelled) setRows(data || [])
      })
      .catch(e => {
        if (!cancelled) {
          setRows([])
          setError(e?.message || 'Could not load staff utilization.')
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [client, projectId, month])

  return { rows, loading, error }
}
